import CheckBoxOutlineBlankOutlinedIcon from '@mui/icons-material/CheckBoxOutlineBlankOutlined';
import CheckBoxOutlinedIcon from '@mui/icons-material/CheckBoxOutlined';
import Autocomplete from '@mui/lab/Autocomplete';
import { Checkbox, Chip, TextField } from '@mui/material';
import _ from 'lodash';
import React from 'react';
import { Controller } from 'react-hook-form';

export function AppAutocomplete({ field, control, errors, getValues, onValueChange = () => {}, readOnly = false, setValue, ...rest }) {
    return (
        <Controller
            name={field.id}
            defaultValue={field.defaultValue || {}}
            control={control}
            render={({ field: { onChange, value } }) => {
                const _options = _.get(getValues(), [field.id + '_options'], []) || [];
                let val = {};
                const fIdx = _options.findIndex((o) => o.id === value);
                if (fIdx > -1) {
                    val = _options[fIdx];
                }
                const props = {};
                if (Boolean(readOnly)) {
                    props['InputProps'] = {
                        readOnly: true,
                    };
                }
                return (
                    <Autocomplete
                        id={field.id}
                        options={_options}
                        getOptionLabel={(option) => {
                            if (!option) return '';

                            return option.label || '';
                        }}
                        onChange={(e, items) => {
                            onChange(_.get(items, ['id']));
                            onValueChange(field.id, items);
                        }}
                        value={val}
                        {...rest}
                        renderInput={(params) => <TextField {...params} label={field.label} variant="outlined" {...props} />}
                    />
                );
            }}
        />
    );
}

export function AppChipAutocomplete({ field, control, errors, getValues, readOnly = false, onValueChange = () => {}, setValue, ...rest }) {
    return (
        <Controller
            name={field.id}
            defaultValue={field.defaultValue || []}
            control={control}
            render={({ field: { onChange, value } }) => {
                const _options = _.get(getValues(), [field.id + '_options'], []) || [];
                let val = (value || []).map((id) => {
                    const fIdx = _options.findIndex((o) => o.id === id);
                    if (fIdx < 0) {
                        return {};
                    }

                    return {
                        id,
                        label: _options[fIdx].label || _options[fIdx].name,
                    };
                });

                // const props = {}
                // console.log("readOnlyreadOnlyreadOnly", readOnly)
                // if (Boolean(readOnly)) {
                //   props["InputProps"] = {
                //     readOnly: true
                //   }
                // }
                return (
                    <Autocomplete
                        id={field.id}
                        options={_options}
                        // InputProps={{readOnly: Boolean(readOnly)}}
                        disabled={Boolean(readOnly)}
                        getOptionLabel={(option) => {
                            if (!option) return '';

                            return option.label || '';
                        }}
                        onChange={(e, items, reason) => {
                            let _items = [];
                            if (reason === 'create-option') {
                                const newOpt = _.last(items);
                                if (!(value || []).includes(newOpt)) {
                                    _items = items[items.length - 1] = {
                                        id: newOpt,
                                        label: newOpt,
                                    };
                                } else {
                                    _items = items[items.length - 1] = {};
                                }
                            }
                            _items = items.map((i) => i.id).filter((i) => !_.isEmpty(i));

                            onChange(_items);
                            onValueChange(field.id, _items);
                        }}
                        value={val}
                        {...rest}
                        limitTags={field?.limitTags || null}
                        multiple
                        freeSolo
                        filterOptions={(options, state) => {
                            return (options || []).filter((o) => !(value || []).includes(o.id));
                        }}
                        renderInput={(params) => <TextField {...params} label={field.label} variant="outlined" />}
                        // renderTags={(value, getTagProps) => {
                        //   return value.map((option, index) => <Chip variant="default" label={option.label} {...getTagProps({ index })} />);
                        // }}
                        // onInputChange={(event, value, reason) => {
                        //   if (reason === "reset") {
                        //     valRef.current = ""
                        //   } else if (reason === "input") {
                        //     valRef.current = value
                        //   }
                        // }}
                    />
                );
            }}
        />
    );
}

export function AppChipDiaAutocomplete({
    field,
    control,
    errors,
    getValues,
    size = 'small',
    readOnly = false,
    onValueChange = () => {},
    renderTags,
    setValue,
    watch,
    ...rest
}) {
    // const classes = useStyles();

    /**
     * renders
     */
    return (
        <Controller
            name={field.id}
            defaultValue={field.defaultValue || []}
            control={control}
            render={({ field: { onChange, value } }) => {
                const _options = getValues(`${field.id}_options`) || [];
                if (onValueChange) {
                    onValueChange(value);
                }
                return (
                    <Autocomplete
                        multiple
                        id={field.id}
                        options={_options}
                        disableCloseOnSelect
                        getOptionLabel={(option) => option.label || option.key}
                        renderOption={(props, option) => {
                            const checked = (value || []).map((i) => i.id).includes(option.id);
                            return (
                                <div {...props}>
                                    <Checkbox
                                        icon={<CheckBoxOutlineBlankOutlinedIcon color="primary" />}
                                        checkedIcon={<CheckBoxOutlinedIcon color="primary" />}
                                        checked={checked}
                                        onChange={(e) => {
                                            const checked = e.target.checked;
                                            if (!checked) {
                                                onChange(value.filter((v) => v.id !== option.id));
                                            }
                                        }}
                                    />
                                    {option.label || option.key}
                                </div>
                            );
                        }}
                        onChange={(event, items) => {
                            let _items = _.uniqBy(items, 'id');
                            onChange(_items);
                        }}
                        value={value || []}
                        renderInput={(params) => <TextField {...params} variant="outlined" label={field.label} placeholder="Select" />}
                        renderTags={(value, getTagProps) => {
                            if (watch && watch('renderTags')) {
                                value = watch('renderTags');
                            }

                            return value.map((option, index) => (
                                <Chip size={size} variant="default" color="primary" label={option.label} {...getTagProps({ index })} />
                            ));
                        }}
                        size={size}
                        fullWidth
                    />
                );
            }}
        />
    );
}
